export default __webpack_public_path__ + "static/media/comments_disabled_black_24dp.857c84e2.svg";